import { NavLink, Outlet } from "react-router-dom";

const TABS = [
  { to: "whitelist", label: "Whitelist" },
  { to: "profile", label: "Profile" },
  { to: "appearance", label: "Appearance" },
];

export function SettingsLayout() {
  return (
    <div className="px-6 py-8">
      <div className="mx-auto max-w-content space-y-6">
        <h1 className="text-2xl font-semibold tracking-tight text-text-primary">
          Einstellungen
        </h1>
        <nav className="flex gap-1 border-b border-border-primary">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              className={({ isActive }) =>
                `-mb-px border-b-2 px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "border-accent text-text-primary"
                    : "border-transparent text-text-secondary hover:text-text-primary"
                }`
              }
            >
              {t.label}
            </NavLink>
          ))}
        </nav>
        <Outlet />
      </div>
    </div>
  );
}
